export default function Contacto() {
  return (
    <div>
      <h1 className="text-center">Contacto</h1>
    </div>
  );
}
